import React from 'react';
import styled from 'styled-components';
import { IDashboardFolderFieldsFragment } from '../../../../utils/apollo/graphqlSchema';
import {
  DEFAULT_NEW_FOLDER_NAME,
  FOLDER_NAME_MAX_LENGTH,
} from '../../utils/constants';
import { SvgIcon } from '../../../../components/Icon';
import { EditableTextInput } from '../../../../components/Form';
import useCreateFolder from '../../utils/useCreateFolder';
import { theme } from '../../../../styles/theme';

interface IProps {
  parentFolderId: string | null;
  onSubmit: (newFolder: IDashboardFolderFieldsFragment) => void;
  onCancel: () => void;
}

const Container = styled.div`
  display: flex;
  align-items: center;
  column-gap: 8px;
  padding: 5px 12px;
`;

const DashboardFolderWidgetNewFolder = ({
  parentFolderId,
  onSubmit,
  onCancel,
}: IProps) => {
  const createFolder = useCreateFolder({
    parentFolderId,
    onSubmit,
    onError: onCancel,
  });

  return (
    <Container>
      <SvgIcon
        name="folder"
        width={16}
        height={16}
        customFill={theme.colors.secondary800}
      />
      <EditableTextInput
        onSubmit={createFolder}
        onCancel={onCancel}
        value={DEFAULT_NEW_FOLDER_NAME}
        limit={FOLDER_NAME_MAX_LENGTH}
        inputSize="XS"
        allowEmpty={false}
        autoFocus={true}
        allowSameValue={true}
      />
    </Container>
  );
};

export default DashboardFolderWidgetNewFolder;
